// import {
//   TextField,
//   MenuItem,
//   InputAdornment,
//   Select,
//   FormControl,
// } from "@mui/material";

// const TimeDurationField = ({
//   value = { day: 0, hour: 0, minute: 0 },
//   onChange,
//   maxDays = 100,
//   maxHours = 23,
//   maxMinutes = 59,
//   label = "Duration",
//   disable = false,
// }) => {
//   const { day, hour, minute } = value;

//   const handleChange = (key, val) => {
//     onChange?.({ ...value, [key]: val });
//   };

//   const displayText = `${day}d ${hour}h ${minute}m`;

//   return (
//     <TextField
//       fullWidth
//       size="small"
//       disabled={disable}
//       sx={{ background: disable ? "#f5f5f5" : "" }}
//       value={day && hour && minute && displayText}
//       InputProps={{
//         readOnly: true,
//         startAdornment: (
//           <InputAdornment position="start">
//             {/* Day select */}
//             <FormControl size="small" sx={{ minWidth: 70, mr: 1 }}>
//               <Select
//                 disabled={disable}
//                 sx={{ background: disable ? "#f5f5f5" : "" }}
//                 value={day}
//                 variant="standard"
//                 disableUnderline
//                 onChange={(e) => handleChange("day", e.target.value)}
//               >
//                 {[...Array(maxDays + 1).keys()].map((d) => (
//                   <MenuItem key={d} value={d}>
//                     {d}d
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* Hour select */}
//             <FormControl size="small" sx={{ minWidth: 70, mr: 1 }}>
//               <Select
//                 value={hour}
//                 variant="standard"
//                 disableUnderline
//                 disabled={disable}
//                 sx={{ background: disable ? "#f5f5f5" : "" }}
//                 onChange={(e) => handleChange("hour", e.target.value)}
//               >
//                 {[...Array(maxHours + 1).keys()].map((h) => (
//                   <MenuItem key={h} value={h}>
//                     {h}h
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* Minute select */}
//             <FormControl size="small" sx={{ minWidth: 70 }}>
//               <Select
//                 variant="standard"
//                 disableUnderline
//                 value={minute}
//                 disabled={disable}
//                 sx={{ background: disable ? "#f5f5f5" : "" }}
//                 onChange={(e) => handleChange("minute", e.target.value)}
//               >
//                 {[...Array(maxMinutes + 1).keys()].map((m) => (
//                   <MenuItem key={m} value={m}>
//                     {m}m
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl>
//           </InputAdornment>
//         ),
//       }}
//     />
//   );
// };

// export default TimeDurationField;
import {
  TextField,
  MenuItem,
  InputAdornment,
  Select,
  FormControl,
} from "@mui/material";

const TimeDurationField = ({
  value = { day: "00", hour: "00", minute: "00" },
  onChange,
  maxDays = 100,
  maxHours = 23,
  maxMinutes = 59,
  label = "Duration",
  disable = false,
}) => {
  const { day, hour, minute } = value;

  const handleChange = (key, val) => {
    onChange?.({ ...value, [key]: val });
  };

  const displayText = `${day}d ${hour}h ${minute}m`;

  // helper to generate padded options
  const getOptions = (max, suffix) =>
    [...Array(max + 1).keys()].map((n) => {
      const padded = String(n).padStart(2, "0");
      return (
        <MenuItem key={padded} value={padded}>
          {padded}
          {suffix}
        </MenuItem>
      );
    });

  return (
    <TextField
      fullWidth
      size="small"
      disabled={disable}
    //   label={label}
      sx={{ background: disable ? "#f5f5f5" : "" }}
      value={displayText}
      InputProps={{
        readOnly: true,
        startAdornment: (
          <InputAdornment position="start">
            {/* Day select */}
            <FormControl size="small" sx={{ minWidth: 70, mr: 1 }}>
              <Select
                disabled={disable}
                value={day}
                variant="standard"
                disableUnderline
                sx={{ background: disable ? "#f5f5f5" : "" }}
                onChange={(e) => handleChange("day", e.target.value)}
              >
                {getOptions(maxDays, "d")}
              </Select>
            </FormControl>

            {/* Hour select */}
            <FormControl size="small" sx={{ minWidth: 70, mr: 1 }}>
              <Select
                disabled={disable}
                value={hour}
                variant="standard"
                disableUnderline
                sx={{ background: disable ? "#f5f5f5" : "" }}
                onChange={(e) => handleChange("hour", e.target.value)}
              >
                {getOptions(maxHours, "h")}
              </Select>
            </FormControl>

            {/* Minute select */}
            <FormControl size="small" sx={{ minWidth: 70 }}>
              <Select
                disabled={disable}
                value={minute}
                variant="standard"
                disableUnderline
                sx={{ background: disable ? "#f5f5f5" : "" }}
                onChange={(e) => handleChange("minute", e.target.value)}
              >
                {getOptions(maxMinutes, "m")}
              </Select>
            </FormControl>
          </InputAdornment>
        ),
      }}
    />
  );
};

export default TimeDurationField;
